import type { Node as PMNode } from '@tiptap/pm/model';
import type { EditorView } from '@tiptap/pm/view';

const TASK_CHECKBOX_SELECTOR = 'ul[data-type="taskList"] > li > label > input[type="checkbox"]';

type TIsPositionInsideField = (doc: PMNode, position: number) => boolean;

const getTemplateCheckboxClickHandler =
  (isPositionInsideField: TIsPositionInsideField) =>
  (view: EditorView, event: Event): boolean => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || !target.matches(TASK_CHECKBOX_SELECTOR)) return false;

    const taskItem = target.closest('li[data-checked]');
    if (!taskItem || !view.dom.contains(taskItem)) return false;

    // The checkbox flips its own box before the editor saves that change. Outside a field the save is
    // rejected but the box isn't flipped back, so cancel the flip to keep view and data in sync.
    const position = view.posAtDOM(taskItem, 0);
    if (isPositionInsideField(view.state.doc, position)) return false;

    event.preventDefault();
    return true;
  };

export default getTemplateCheckboxClickHandler;
